export default {
    UNDO: "Отменить"
};
